module.exports = __webpack_public_path__ + "img/20.61517010.jpg";